/* eslint-disable */
import { getApolloClient } from '@/apollo';
import { ReturnTransfers } from '@/views/BookingList/graphql/Orders';
import useReturnTransferService, { normalizeOrders, isReturnableOrder } from '@/services/ReturnTransfers';

function fetchReturnTransfers(variables, apolloConfig) {
  return getApolloClient().query({
    query: ReturnTransfers,
    variables,
    ...apolloConfig,
  });
}

const returnTransfers = {
  namespaced: true,
  state: {
    init: false,
    availableHash: {},
  },
  getters: {
    has: ({ availableHash }) => orderId => availableHash[orderId]
      && availableHash[orderId] === true,
  },
  mutations: {
    SET_AVAILABLE_RETURN_TRANSFERS: (state, payload) => {
      state.availableHash = payload;
    },
    SET_WITH_INIT_AVAILABLE_RETURN_TRANSFERS: (state, payload) => {
      state.init = true;
      state.availableHash = payload;
    },
  },
  actions: {
    fetchReturnTransfers: ({ state, commit } , { orders, init = false }) => {
      if (state.init) {
        return;
      }
      const normalizedOrders = normalizeOrders(orders.filter(isReturnableOrder));
      if (!normalizeOrders.length) {
        return;
      }
      const [variables, normalizerReturnTransfers] = useReturnTransferService(normalizedOrders);
      return fetchReturnTransfers(variables, { fetchPolicy: 'cache-first' })
        .then(response => normalizerReturnTransfers(response.data.transfers.results))
        .then(data => {
          const mutationName = init 
            ? 'SET_WITH_INIT_AVAILABLE_RETURN_TRANSFERS'
            : 'SET_AVAILABLE_RETURN_TRANSFERS';
          return commit(mutationName, data);
        });
    },
  },
}

export default returnTransfers;


// WEBPACK FOOTER //
// ./src/store/modules/returnTransfers.js